import { SearchActions } from "~/types/actions.enum";
import { TCompanyAction, TCompanyState } from "./company.state";

// ✅ Company reducer logic
export const companyReducer = (state: TCompanyState, action: TCompanyAction): TCompanyState => {
    switch (action.type) {
        case SearchActions.SET_COMPANY_ITEMS: {
            return {
                ...state,
                companies: action.payload,
                selectedCompanyIds: [],
                totalSelected: 0
            };
        }

        case SearchActions.SET_COMPANY_FILTERS: {
            return {
                ...state,
                filters: action.payload
            };
        }

        case SearchActions.SET_SELECTED_COMPANY: {
            return {
                ...state,
                selectedCompanyIds: [...state.selectedCompanyIds, action.payload],
                totalSelected: state.selectedCompanyIds.length + 1
            };
        }

        case SearchActions.REMOVE_SELECTED_COMPANY: {
            const currentTotal = state.selectedCompanyIds.length;
            const total = currentTotal > 0 ? currentTotal - 1 : 0;
            return {
                ...state,
                selectedCompanyIds: state.selectedCompanyIds.filter(id => id !== action.payload),
                totalSelected: total
            };
        }

        case SearchActions.RESET_SELECTION: {
            return {
                ...state,
                selectedCompanyIds: [],
                totalSelected: 0
            };
        }

        default:
            return state;
    }
};
